export default __webpack_public_path__ + "static/tabs-importance-dont-492c31b51b41b0d20e3ea1dda6633b6e.png";